export enum IntegrationsEnum {
  square = 'square',
  reserveWithGoogle = 'reserveWithGoogle',
}
